import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddChipModel } from 'src/app/models/add-chip.model';
import { SelectModel } from 'src/app/models/select.model';
import { RegionService } from 'src/app/services/region.service';
import { FdChipCollectionComponent } from '../fd-chip-collection/fd-chip-collection.component';
import { CountryService } from 'src/app/services/country.service';
import { InDepthFilterOptionsModel } from 'src/app/models/mecs-models/in-depth-filter-options.model';
import { InDepthFilterSelectOptionsModel } from 'src/app/models/mecs-models/in-depth-filter-seletc-options.model';
import { InDepthFilterReuqestModel } from 'src/app/models/mecs-models/in-depth-filter-request.model';

@Component({
  selector: 'app-mecs-in-depth-filter',
  templateUrl: './mecs-in-depth-filter.component.html',
  styleUrls: ['./mecs-in-depth-filter.component.scss'],
})
export class MecsInDepthFilterComponent {
  @ViewChildren(FdChipCollectionComponent)
  fdChipCollectionComponents!: QueryList<FdChipCollectionComponent>;
  @Input() isFiltersRemoved!: boolean;

  @Output() filter = new EventEmitter<InDepthFilterReuqestModel>();

  selectConfiguration: SelectModel[] = [
    {
      type: 'Country',
      placeholder: 'Select country',
      chipColor: '#E1C3CD',
      options: [],
    },
    {
      type: 'Solution',
      placeholder: 'Select solution',
      chipColor: '#82BCEA',
      options: [],
    },
  ];

  filterOptions!: InDepthFilterOptionsModel;
  filterOptionsRegion!: InDepthFilterSelectOptionsModel;

  isFilterContainerOpen = false;
  state: boolean = false;
  filterRequest: InDepthFilterReuqestModel = {
    countries: [],
    solutions: [],
  };
  regionIdFromUrl: number | null = null;

  constructor(
    private regionService: RegionService,
    private route: ActivatedRoute,
    private countryService: CountryService
  ) {}

  ngOnInit(): void {
    this.getInDepthFilterOptions();
  }

  getInDepthFilterOptions(): void {
    this.countryService.getInDepthFilterOptions().subscribe((response) => {
      this.filterOptions = response;

      this.selectConfiguration[0].options = this.filterOptions.countries;
      this.selectConfiguration[1].options = this.filterOptions.solutions;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFiltersRemoved'] &&
      changes['isFiltersRemoved'].currentValue
    ) {
      this.fdChipCollectionComponents.forEach((c) => {
        c.chips = [];
      });
      this.filterRequest = {
        countries: [],
        solutions: [],
      };
    }
  }

  onClick(): void {
    this.isFilterContainerOpen = !this.isFilterContainerOpen;
    this.state = this.state === false ? true : false;
  }

  emitFilterRequestModel() {
    this.filterRequest.countries = [];
    this.filterRequest.solutions = [];

    this.fdChipCollectionComponents.forEach((c) => {
      if (c.type?.toLowerCase() === 'country') {
        this.filterRequest.countries.push(...c.chips.map((x) => x.id));
      } else if (c.type?.toLowerCase() === 'solution') {
        this.filterRequest.solutions.push(...c.chips.map((x) => x.id));
      }
    });

    this.filter.emit(this.filterRequest);
  }

  removeChip(e: any): void {
  }

  callAddChipMethod(data: AddChipModel): void {
    const collection = this.fdChipCollectionComponents.find(
      (x) => x.type === data.collectionType
    );

    collection?.addChip(data);

    
  }
}
